/**
 * Hostnames allowed as `?withAPIURL=` overrides: production (`pixai.art`),
 * staging (`*.pixai.art` / `*.pixai.mewtant.co`), test (`*.ring.mewtant.co`),
 * and local dev (loopback + `dev.local`). Anything outside this set can hijack
 * subsequent API traffic — login credentials, request payloads, fabricated
 * responses — so the query-string entry point MUST reject it.
 */
const ALLOWED_HTTPS_SUFFIXES = [
  '.pixai.art',
  '.pixai.mewtant.co',
  '.ring.mewtant.co',
]

const ALLOWED_HTTPS_HOSTS = ['pixai.art']

const ALLOWED_LOOPBACK_HOSTS = ['localhost', '127.0.0.1', 'dev.local']

/**
 * Validate `rawUrl` against the allowlist and return its normalized origin
 * (`protocol://host[:port]`, no path / query / fragment / trailing slash) on
 * accept, or `null` on reject. Stripping the tail matters because downstream
 * code composes URLs with `getApiUrl() + '/auth/...'` and keys the JWT in
 * localStorage by `${getApiUrl()}:token` — a path on the stored value would
 * break both.
 */
export function parseAllowedApiUrl(rawUrl: string): string | null {
  let parsed: URL
  try {
    parsed = new URL(rawUrl)
  } catch {
    return null
  }
  const { protocol, hostname } = parsed
  const loopbackOk =
    (protocol === 'http:' || protocol === 'https:') &&
    ALLOWED_LOOPBACK_HOSTS.includes(hostname)
  const httpsOk =
    protocol === 'https:' &&
    (ALLOWED_HTTPS_HOSTS.includes(hostname) ||
      ALLOWED_HTTPS_SUFFIXES.some(suffix => hostname.endsWith(suffix)))
  if (!loopbackOk && !httpsOk) return null
  return parsed.origin
}
